import React from 'react';
import './Administration.css';

const Administration = () => {
  return (
    <>
     {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>ADMINISTRATION</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Administration</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="admin-container">
        <div className="admin-content">
          {/* Withdrawal Section */}
          <section className="admin-section">
            <h2 className="admin-heading">WITHDRAWAL</h2>
            <p className="admin-text">
              For withdrawing a student and obtaining T.C., Seven days notice accompanied by No dues certificate 
              of the Academy is required. Dues are charged for the whole of academic session.
            </p>
          </section>

          {/* Registration Section */}
          <section className="admin-section">
            <h2 className="admin-heading">REGISTRATION</h2>
            <p className="admin-text">
              Registration is done from 25th Feb. to 30 April. Prospectus and Admission form can be obtained 
              from the Academy office between 8 AM to 2 PM on working days only.
            </p>
            <ol className="admin-list">
              <li>Admission is granted purely on merit.</li>
              <li>Guardians along with the child should visit the Academy and contact the Principal for personal interview.</li>
              <li>Students migrating form the other school and fresh cases will have toe take an Entrance Test and 
                Secure at least 60% marks for making themselves eligible.</li>
              <li>Entry age in Pre-Nursery is 2 Yrs. 3 months.</li>
            </ol>
          </section>

          {/* R.T.E. Rules Section */}
          <section className="admin-section">
            <h2 className="admin-heading">R.T.E. RULES</h2>
            <p className="admin-text">
              R.T.E. rules are followed as per Govt. Norms.
            </p>
          </section>

          {/* Conveyance Facility Section */}
          <section className="admin-section">
            <h2 className="admin-heading">CONVEYANCE FACILITY</h2>
            <p className="admin-text">
              Academy buses are available. Bus stops will be decided by the Academy.
            </p>
          </section>

          {/* Absence & Leave Section */}
          <section className="admin-section">
            <h2 className="admin-heading">ABSENCE & LEAVE</h2>
            <p className="admin-text">
              Punctuality and regular attendance are essential. Repeated or unexplained absence for more than 7 
              consecutive days will lead to removal of the child's name from the Academy rolls. Re admission if 
              granted will be conditional.
            </p>
            <p className="admin-text">
              Leave must be got sanctioned through an application written and duly recommended by the parents/guardian 
              of the students.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Administration;